module.exports = __webpack_public_path__ + "static/media/19ESCAP33.6b72ffdf.jpg";